import userServices from "../services/user"
import authServices from "../services/auth"
import global from "../config/global"
import storeActions from "../store/actions"

export const mergeJsonContent = (oldData, newData) => {
  if (!newData) {
    return oldData
  }
  if (typeof oldData !== 'object') {
    return newData || oldData
  }
  const jsonData = { ...oldData, ...newData }
  const keys = Object.keys(jsonData)
  keys.forEach(key => {
    jsonData[key] = mergeJsonContent(oldData[key], newData[key])
  });
  return jsonData;
}

export const fetchUserInfo = async () => {
  const userInfo = global.store.getState().auth.userInfo;
  await userServices.get_account().then(async (response) => {
    const userPmPrelogin = await userServices.get_prelogin();
    const userPm = await userServices.user_pm();
    global.store.dispatch(storeActions.updateUserInfo({
      ...userInfo,
      ...response,
      ...userPmPrelogin,
      ...userPm,
    }));
    await global.jsCore.vaultTimeoutService.setVaultTimeoutOptions(userPm.timeout, userPm.timeout_action);
  }).catch(() => {
    authServices.logout()
  });
}

export const openNewTab = (link) => {
  window.open(link, '_blank')
}


